import React from "react";
import { Spinner } from "react-bootstrap";

const CustomSpinner = () => {
  return (
    <>
      <Spinner
        animation="border"
        variant="light"
        className="text-muted"
        as="span"
        size="sm"
      />{" "}
      Submitting...
    </>
  );
};

export default CustomSpinner;
